//#region src/sound/sound-utils.ts
/**
* Pure helpers of the sound service — unit-testable without Web Audio.
*/
/** Random variant key: prefix + 1…count, e.g. pickRandomKey("cardShove", 4). */
var pickRandomKey = (prefix, count, random = Math.random) => `${prefix}${Math.floor(random() * count) + 1}`;
/**
* Run `task` for every item with at most `limit` in flight; settles all,
* never rejects (the caller decides what a failure means).
*/
async function runLimited(items, limit, task) {
	const results = new Array(items.length);
	let next = 0;
	const worker = async () => {
		while (next < items.length) {
			const index = next++;
			try {
				results[index] = {
					status: "fulfilled",
					value: await task(items[index])
				};
			} catch (reason) {
				results[index] = {
					status: "rejected",
					reason
				};
			}
		}
	};
	const workers = Array.from({ length: Math.max(1, Math.min(limit, items.length)) }, () => worker());
	await Promise.all(workers);
	return results;
}
//#endregion
export { pickRandomKey, runLimited };
